import useTranslation from 'next-translate/useTranslation'
import ShoppingBagOutlineIcon from '@ancon/wildcat-ui/shared/icons/shopping-bag-outline.svg'
import WalletIcon from '@ancon/wildcat-ui/shared/icons/wallet-outline.svg'
import EditAccountIcon from '@ancon/wildcat-ui/shared/icons/pen-line-outline.svg'

import BodyText from '../../../../app/components/BodyText'
import InteractiveDiv from '../../InteractiveDiv'
import useAppSelector from '../../../../../store/hooks/useAppSelector'
import isAppWhiteLabeled from '../../../../app/utils/isAppWhiteLabeled'
import { ProfileAction } from '../../../constants'
import { clientContextIsAnonymousCustomerSelector } from '../../../../clientContext/store/clientContextSelectors'
import { authCustomerIsLoggedInSelector } from '../../../../auth/store/authSelectors'
import { preOrderUserSelector } from '../../../../preOrder/store/preOrderSelectors'

import styles from './MobileSideDrawerProfileAction.module.scss'

interface MobileSideDrawerProfileActionProps {
  action: ProfileAction
  onClick?: () => void
  disabled?: boolean
}

export default function MobileSideDrawerProfileAction({
  action,
  onClick,
  disabled,
}: MobileSideDrawerProfileActionProps) {
  const { t } = useTranslation('common')

  const isAnonymousCustomer = useAppSelector(
    clientContextIsAnonymousCustomerSelector,
  )

  const isLoggedIn = useAppSelector(authCustomerIsLoggedInSelector)

  const preOrderUser = useAppSelector(preOrderUserSelector)

  const isWhiteLabeled = isAppWhiteLabeled()

  function getActionIcon() {
    switch (action) {
      case ProfileAction.MyOrders:
        return <ShoppingBagOutlineIcon />

      case ProfileAction.MyAccount:
        return <EditAccountIcon />

      case ProfileAction.MyWallets:
        return <WalletIcon />

      default:
        return null
    }
  }

  function getActionLabel() {
    switch (action) {
      case ProfileAction.MyOrders:
        return t('components.navBar.profile.myOrders')

      case ProfileAction.MyAccount:
        return t('auth.manageAccount')

      case ProfileAction.MyWallets:
        return t('components.navBar.profile.myWallets')

      case ProfileAction.ChangeProfile:
        return t('components.navBar.profile.changeProfile')

      case ProfileAction.GuestOnBoarding:
        return isWhiteLabeled
          ? t('components.navBar.profile.createProfile')
          : t('components.navBar.profile.createAnconProfile')

      case ProfileAction.SignOut:
        return isAnonymousCustomer || (!!preOrderUser && !isLoggedIn)
          ? t('components.navBar.profile.exitSession')
          : t('components.navBar.profile.signOut')

      default:
        return null
    }
  }

  return (
    <InteractiveDiv
      className={styles.action}
      onClick={onClick}
      disabled={disabled}
    >
      {getActionIcon()}
      <BodyText>{getActionLabel()}</BodyText>
    </InteractiveDiv>
  )
}
